import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import ConfirmPasswordFunctional from './component/confirm-password';
import { withReducer } from '@store/reducerLoader';
import reducer from '../login/reducer';
import sagas from '../login/sagas';

const ConfirmPassword = () => {
	const history = useHistory();
	const params = useParams();
	return <ConfirmPasswordFunctional history={history} params={params} />;
};

const ReducedScreen = withReducer('user', reducer, sagas)(ConfirmPassword);

export default ReducedScreen;
